import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 020
        'numConvocatoria' : 'Convocatoria No. 020/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N40-2026.',
        'vigencia' : '15 al 26 de junio de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Puerto Progreso, colonia El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }20/N40/N40.rar`,
        'start' : '2026-06-15',
        'end' : '2026-06-26',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N39-2026.',
        'vigencia' : '15 al 26 de junio de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Puerto Madero, colonia El Palmar, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }20/N39/N39.rar`,
        'start' : '2026-06-15',
        'end' : '2026-06-26',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N38-2026.',
        'vigencia' : '15 al 26 de junio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de CGI de Zimapán; ubicada en la localidad de , Municipio de Zimapán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }20/N38/N38.rar`,
        'start' : '2026-06-15',
        'end' : '2026-06-26',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N37-2026.',
        'vigencia' : '15 al 26 de junio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de CGI Tenango de Doria; ubicada en la localidad y Municipio de Tenango de Doria, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }20/N37/N37.rar`,
        'start' : '2026-06-15',
        'end' : '2026-06-26',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N36-2026.',
        'vigencia' : '15 al 26 de junio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de Laboratorio Dental; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }20/N36/N36.rar`,
        'start' : '2026-06-15',
        'end' : '2026-06-26',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N35-2026.',
        'vigencia' : '15 al 26 de junio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de Centro Gerontológico Integral de Tlahuelilpan; ubicada en la localidad y Municipio de Tlahuelilpan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }20/N35/N35.rar`,
        'start' : '2026-06-15',
        'end' : '2026-06-26',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 019
        'numConvocatoria' : 'Convocatoria No. 019/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N34-2026.',
        'vigencia' : '11 al 24 de junio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de Inmueble para Construcción del Centro Social y Cultural en el municipio de Progreso de Obregón.; ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }19/N34/N34.rar`,
        'start' : '2026-06-11',
        'end' : '2026-06-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 018
        'numConvocatoria' : 'Convocatoria No. 018/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N33-2026.',
        'vigencia' : '8 al 19 de junio de 2026.',
        'descripcionProcedimiento' : 'Construcción del nuevo Salón de Plenos del Congreso de Estado de Hidalgo, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }18/N33/N33.rar`,
        'start' : '2026-06-08',
        'end' : '2026-06-19',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 017
        'numConvocatoria' : 'Convocatoria No. 017/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N32-2026.',
        'vigencia' : '8 al 19 de junio de 2026.',
        'descripcionProcedimiento' : '"Rehabilitación general de sanitarios en oficinas centrales del sistema DIF Hidalgo, en Pachuca de Soto Hgo."; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligasipdus }17/N32/N32.rar`,
        'start' : '2026-06-08',
        'end' : '2026-06-19',
        'procedimiento' : 'Licitación Pública',
    }
]